import * as fp from "../../../date-fns/fp.js";
window.dateFns = {
  ...window.dateFns,
  fp
};